import React, { useEffect, useState, useRef } from "react";
import { LayoutHome } from "../LayoutHome";
import { Panel, SelectPicker, Text } from "rsuite";
import { Button, Input, Splitter, Table, notification, Space } from "antd";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import { LucideEdit, LucideSave } from "lucide-react";
import { FaEdit } from "react-icons/fa";
import Highlighter from "react-highlight-words";
import {
  getGruposLab,
  getListMarcadoresLab,
  getMarcadoresLab,
	saveGrupoLab,
	saveMarcadorLab,
} from "../Services/CatalogosServices";

export const Laboratorios = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [grupo, setGrupo] = useState("");
  const [idGpo, setIdGpo] = useState("0");
  const [idGpoMarc, setIdGpoMarc] = useState("0");
  const [idMarcador, setIdMarcador] = useState("0");
  const [marcador, setMarcador] = useState("");
  const [dataGrupos, setDataGrupos] = useState([]);
  const [dataMarcadores, setDataMarcadores] = useState([]);
  const [dataGruposMarc, setDataGruposMarc] = useState([]);

  const initialized = useRef(false);
  const [api, contextHolder] = notification.useNotification();

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{ padding: 8 }}
        onKeyDown={(e) => e.stopPropagation()}
        tabIndex={"-1"}
      >
        <Input
          ref={searchInput}
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Resetear
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const editaGrupo = (props) => {
    setIdGpo(props.idGpo);
    setGrupo(props.grupo);
  };

  const columnsGrupos = [
    {
      title: "Grupo",
      dataIndex: "label",
      width: "80%",
      key: "label",
      sorter: (a, b) => a.label.length - b.label.length,
      ...getColumnSearchProps("label"),
    },
    {
      title: "Acción",
      dataIndex: "x",
      width: "10%",
      key: "x",
      align: "center",
      render: (text, record) => (
        <Button
          variant="text"
          color="primary"
          icon={<LucideEdit size={16}></LucideEdit>}
          onClick={() => {
            editaGrupo({
              idGpo: record.value,
              grupo: record.label,
            });
          }}
        ></Button>
      ),
    },
  ];

  const columnsMarcadores = [
    {
      title: "Grupo",
      dataIndex: "grupo",
      width: "40%",
      key: "grupo",
      sorter: (a, b) => a.grupo.length - b.grupo.length,
      ...getColumnSearchProps("grupo"),
    },
    {
      title: "Marcador",
      dataIndex: "marcador",
      width: "40%",
      key: "marcador",
      sorter: (a, b) => a.marcador.length - b.marcador.length,
      ...getColumnSearchProps("grupo"),
    },
    {
      title: "Acción",
      dataIndex: "x",
      width: "10%",
      key: "x",
      align: "center",
      render: (text, record) => (
        <Button
          variant="text"
          color="primary"
          icon={<LucideEdit size={16}></LucideEdit>}
          onClick={() => {
            editaGrupo({
              idGpo: record.idGpo,
            });
          }}
        ></Button>
      ),
    },
  ];

  const loadGruposMarcadores = async () => {
    await getGruposLab(idNegocio)
      .then(async (res) => {
        setDataGruposMarc(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const loadGrupos = async () => {
    await getGruposLab(idNegocio)
      .then((res) => {
        setDataGrupos(res);
      })
      .then(async (res) => {
        getListMarcadoresLab(idNegocio).then((res) => {
          setDataMarcadores(res);
        });
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

	const saveGrupo = async () => {
		const data = {
			IdConsultorio: idNegocio,
			IdGpo: idGpo,
			NomGrupo: grupo,
			Activo: 1,
		};

		await saveGrupoLab(data).then(res => {
			if(res.data > 0){
				successNotification("Grupo", "Se ha registrado de forma correcta el grupo.");
				loadGrupos().then(res => {
					setGrupo("");
					setIdGpo("0");
					loadGruposMarcadores();
				});
			}else{
				errorNotificaction("Error_SaveGpo", "Ha ocurrido un error al guardar.");
			}
		}).catch(err => {
			errorNotificaction(err.name, err.message);
		});
	};

	const saveMarcador = async () => {
		const data = {
			IdConsultorio: idNegocio,
			IdGpo: idGpoMarc,
			IdMarcador: idMarcador,
			Marcador: marcador,
			Activo: 1
		};
		await saveMarcadorLab(data).then(res => {
			if(res.data > 0){
				successNotification("Marcador", "Se ha registrado de forma correcta el marcador.");
				setIdGpoMarc("0");
				setIdMarcador("0");
				setMarcador("");
				loadGrupos().then(res => {
					loadGruposMarcadores();
				});
			}
		}).catch(err => {
			errorNotificaction(err.name, err.message);
		});
	}

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadGrupos().then(res => {
				loadGruposMarcadores();
			});
    }
  }, []);

  return (
    <>
      <title>Laboratorios</title>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          {
            title: (
              <a
                href="/#/App/Home/Laboratorios"
                style={{ textDecoration: "none" }}
              >
                Laboratorios
              </a>
            ),
          },
        ]}
        selectedKey={"Laboratorios"}
      >
        {contextHolder}
        <Panel bordered>
          <Splitter>
            <Splitter.Panel
              style={{ padding: "10px", overflowX: "hidden" }}
              defaultSize="40%"
              min="30%"
              max="80%"
            >
              <Text size={"xl"}>Grupos</Text>
              <br></br>
              <div className="row mb-2">
                <div className="col-lg-8 col-md-8 col-sm-8">
                  <Text weight="semibold">Nombre del grupo</Text>
                  <Input value={grupo} onChange={(e) => setGrupo(e.target.value)} />
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <br></br>
                  <Button
                    type="primary"
                    icon={<LucideSave size={16}></LucideSave>}
                    disabled={grupo !== "" ? false : true}
										onClick={saveGrupo}
                  >
                    Guardar
                  </Button>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Table
                    key={`tbl1`}
                    bordered
                    size="small"
                    rowKey={(record) => `${record.value}`}
                    columns={columnsGrupos}
                    dataSource={dataGrupos}
                    pagination={{ pageSize: 5 }}
                  />
                </div>
              </div>
            </Splitter.Panel>
            <Splitter.Panel
              style={{ padding: "10px", overflowX: "hidden" }}
              defaultSize="60%"
              min="40%"
              max="80%"
            >
              <Text size={"xl"}>Marcadores</Text>
              <br></br>
              <div className="row mb-2">
                <div className="col-lg-4 col-md-4 col-sm-4">
                  <Text weight="semibold">Grupo</Text>
                  <SelectPicker
                    value={idGpoMarc}
                    data={dataGruposMarc}
                    block
                    placeholder="--SELECCIONA--"
										onChange={(e) => setIdGpoMarc(e)}
                  />
                </div>
                <div className="col-lg-5 col-md-5 col-sm-5">
                  <Text weight="semibold">Marcador</Text>
                  <Input value={marcador} onChange={(e) => setMarcador(e.target.value)} />
                </div>
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <br></br>
                  <Button
                    type="primary"
                    icon={<LucideSave size={16}></LucideSave>}
                    disabled={
                      idGpoMarc !== "0" && marcador !== "" ? false : true
                    }
										onClick={saveMarcador}
                  >
                    Guardar
                  </Button>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Table
                    key={`tbl2`}
                    bordered
                    size="small"
                    rowKey={(record) => `${record.idGpo}-${record.idMarcador}`}
                    columns={columnsMarcadores}
                    dataSource={dataMarcadores}
                    pagination={{ pageSize: 5 }}
                  />
                </div>
              </div>
            </Splitter.Panel>
          </Splitter>
        </Panel>
      </LayoutHome>
    </>
  );
};
